
import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Form, Modal, useAccordionButton } from 'react-bootstrap'
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import _ from "underscore"
import { ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import MiniEditor from '../SessionDiscount/MiniEditor';
import htmlToDraft from 'html-to-draftjs';
import CreatableSelect from "react-select/creatable";

export default function CustomerService() {
    const searchParams = new URLSearchParams(window.location.search)
    const [loading, setLoading] = useState(true)
    const [list, setlist] = useState([])
    const [categorylist, setCategorylist] = useState([])
    const [options, setOptions] = useState([])
    const [modal, setModal] = useState({
        data: {},
        show: false,
        type: "",
        title: ""
    })
    const [editorInitialized, setEditorInitialized] = useState(false);
    const [value, setValue] = useState({})
    const [activeCategory, setActiveCategory] = useState("")
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const updateTextDescription = async (state) => {
        await setEditorState(state);
    };
    const onContentStateChange = (contentState) => {
        setValue((prev) => ({
            ...prev,
            answer: draftToHtml(contentState),
        }));
    }

    useEffect(() => {
        if (editorInitialized || !value?.answer) return;

        const blocksFromHTML = htmlToDraft(value.answer);

        const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
        );

        setEditorState(
            EditorState.createWithContent(contentState)
        );

        setEditorInitialized(true);
    }, [value?.answer, editorInitialized]);

    const getCategoryList = () => {
        Api.GetApi(endPoints.CUSTOMERSERVICECATEGORY).then(res => {
            setLoading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    setCategorylist(res.data.data || [])
                    let arr = []
                    res.data.data.map((cat, i) => {
                        arr.push({ value: cat.category, label: cat.givenName })
                    })
                    setOptions(arr)
                    if (res.data.data[0]?.category) {
                        setActiveCategory(res.data.data[0]?.category || "")
                        getList(res.data.data[0]?.category || "")
                    } else {
                        getList("")
                    }
                }
            }
        })
    }
    const getList = (category) => {
        Api.GetApi(`${endPoints.CUSTOMERSERVICEBYCATEGORY}?category=${category}`).then(res => {
            setLoading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    setlist(res.data.data || [])
                    handleClose()
                }
            }
        })
    }
    const createEditorStateFromHTML = (html) => {
        if (!html) {
            return EditorState.createEmpty();
        }

        const blocksFromHTML = htmlToDraft(html);

        const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
        );

        return EditorState.createWithContent(contentState);
    };

    const handleClose = () => {
        setEditorState(EditorState.createEmpty())
        setValue({})
        setModal({
            ...modal,
            data: {},
            show: false,
            type: "",
            title: ""
        })
    }

    const addNew = () => {
        setModal({
            ...modal,
            show: true,
            type: "add",
            title: "Add new slide"
        })
    }
    const handleChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value })
    }
    const handleSubmit = () => {
        if (!value.category || !value.question || !value.answer) {
            return Api.Alert("Please fill all required fields", "error")
        }
        let data = {
            "category": value.category || "",
            "question": value.question || "",
            "answer": value.answer || "",
        }

        if (modal.type === "add") {
            Api.PostApi(endPoints.CUSTOMERSERVICE, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Added successfully!", "success")
                        getList(activeCategory)
                        getCategoryList()
                    }
                }
            })
        } else {
            Api.PutApi(`${endPoints.CUSTOMERSERVICE}/${modal.data._id}`, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Updated successfully!", "success")
                        getList(activeCategory)
                        getCategoryList()
                    }
                }
            })
        }
    }
    const handleConfirm = () => {
        if (modal.data && modal.data._id) {
            Api.DeleteApi(`${endPoints.CUSTOMERSERVICE}/${modal.data._id}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    Api.Alert(res.data.data, "success")
                    getList(activeCategory)
                }
            })
        }
    }

    const showModal = (data, type) => {
        if (type === "edit") {
            setValue({ ...value, ...data })
            setEditorState(createEditorStateFromHTML(data.answer));
        }
        setModal({
            ...modal,
            data: data,
            show: true,
            type: type,
        })
    }
    console.log("value", value)

    useEffect(() => {
        getCategoryList()
    }, [])

    return (
        <>
            {loading ?
                <div className="loader-line"></div> :
                <main id="main" className="main">
                    <div className="pagetitle pagetitleFilters d-flex flex-wrap  justify-content-between align-items-start">
                        <h1>Customer Service</h1>
                        <Button variant="primary" size='sm' className='me-2 align-items-center' onClick={addNew} >+Add New</Button>
                    </div>
                    <div className="card">
                        <div className="card-body ">
                            <div className='tab_panel mb-3'>
                                {categorylist.length > 0 ?
                                    <>
                                        {categorylist.map((cat, i) => (
                                            <Button
                                                key={i}
                                                variant={activeCategory === cat.category ? "success" : "outline-success"}
                                                size='sm'
                                                className='me-2 mb-2'
                                                onClick={() => {
                                                    setActiveCategory(cat.category)
                                                    getList(cat.category)
                                                }}
                                            >
                                                {cat.givenName}
                                            </Button>
                                        ))}
                                    </>
                                    :
                                    null
                                }
                            </div>
                            <Accordion defaultActiveKey="0">
                                {list.length > 0 ?
                                    <>
                                        {list.map((item, index) => (
                                            <Accordion.Item eventKey={index} key={index}>
                                                <Accordion.Header>
                                                    <div className='custom_accordion_button'>
                                                        {item?.question}
                                                        <div>
                                                            <button className='btn btn-sm btn-outline-success ms-2' onClick={(e) => {
                                                                e.stopPropagation()
                                                                showModal(item, "edit")
                                                            }}><Icon.PencilFill /></button>
                                                            <button className='btn btn-sm btn-outline-danger ms-2' onClick={(e) => {
                                                                e.stopPropagation()
                                                                showModal(item, "delete")
                                                            }}><Icon.TrashFill /></button>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div dangerouslySetInnerHTML={{ __html: item?.answer }}></div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </>
                                    :
                                    <h5>No Records Found</h5>
                                }

                            </Accordion>
                        </div>
                    </div>

                    <Modal show={modal.show} centered size='lg' onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='h5 modalTitleCstm'> {modal.title} </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modal.type === "add" || modal.type === "edit" ? <>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Question</strong></label>
                                        <input placeholder="" type="text" name="question" onChange={handleChange} className="form-control" value={value.question} />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Answer</strong></label>
                                        <MiniEditor
                                            editorState={editorState}
                                            updateTextDescription={updateTextDescription}
                                            onContentStateChange={onContentStateChange}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Category</strong></label>
                                        {/* <select name="category" onChange={handleChange} className="form-control">
                                            {categorylist.map((cat, i) => (
                                                <option key={cat.category} value={cat.givenName}>{cat.givenName}</option>
                                            ))}
                                        </select> */}

                                        <CreatableSelect
                                            options={options}
                                            placeholder="Select or create..."
                                            isClearable
                                            value={
                                                options.find(option => option.value === value.category) ||
                                                (value.category
                                                    ? {
                                                        value: value.category,
                                                        label: value.category
                                                    }
                                                    : null)
                                            }
                                            onChange={(selectedOption) => {
                                                setValue(prev => ({
                                                    ...prev,
                                                    category: selectedOption?.value || ""
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}>
                                        Save
                                    </button>
                                </div>
                            </> : null}
                            {modal.type == "delete" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete this.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}

                        </Modal.Body>
                    </Modal>

                </main>
            }
        </>
    )
}
